import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { formatOrgNr } from '../utils/company.utils';

@Pipe({
  standalone: true,
  name: 'orgnr',
})
@Injectable()
export class OrgnrPipe implements PipeTransform {
  public transform(orgNr: string, orgNrSchema: string): string {
    return formatOrgNr(orgNr, orgNrSchema);
  }
}
